import { AutoComplete } from "primereact/autocomplete";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import { getAllGroups, searchQuery } from "./searchQuery";
import { getChecked, getUniqueObjectsByProperty, removeItem, removeItemById, searchTree } from "./utils";
import "./style.css";
import { FilterMatchMode } from "primereact/api";
import { TreeSelect } from "primereact/treeselect";
import { Dataset } from "./types";
import { Divider } from "primereact/divider";
import { useGetDatasetsCount, useGetPaginatedDatasets, useSearchDatasets } from "api/api-hooks/apiHooks";
import { DatasetInfo } from "api/apiModels";


const DatasetSelection = ({ selectDatasets, updatedDatasets }: { selectDatasets: any; updatedDatasets: Array<Dataset> }) => {
  const [selectedDatasets, setSelectedDatasets] = useState<Array<any>>([]);
  //const [filteredDatasets, setFilteredDatasets] = useState<Array<any>>([]);
  const [selectedDatasetsObjArr, setSelectedDatasetsObjArr] = useState<Array<any>>([]);
  const [allDatasets, setAllDatasets] = useState<Array<any>>([]);
  const [allGroups, setAllGroups] = useState<Array<any>>([]);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    title: { value: null, matchMode: FilterMatchMode.CONTAINS },
    unit: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    group: { value: null, matchMode: FilterMatchMode.IN },
  });
  const [selectedGroups, setSelectedGroups] = useState<any>(null);
  const [searchedQuery, setSearchedQuery] = useState<string | null>(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 20,
    page: 1,
    sortField: undefined,
    sortOrder: null,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getAll = async () => {
      setLoading(true);
      //const datasets = await getAllDatasets();
      //const allDatasets = await DatasetsApi.getPaginatedDatasetsList(null, lazyParams.page, lazyParams.rows);
      const groups = await getAllGroups();
      //setAllDatasets(datasets);
      setAllGroups(groups);
      setLoading(false);
    };
    getAll();
  }, [lazyParams.page, lazyParams.rows]);

  const datasetsCount = useGetDatasetsCount();
  let {
    data: paginatedData,
    isLoading: isLoadingTable,
    isSuccess,
    isFetched,
  } = useGetPaginatedDatasets(null, lazyParams.page, lazyParams.rows, { enabled: true, noCache: true });
  let { data: searchedDatasets, isLoading: isLoadingSearch } = useSearchDatasets(searchedQuery as string, 100, { enabled: !!searchedQuery, noCache: true });

  paginatedData = paginatedData?.map((pd: DatasetInfo) => {return ({...pd, formatedTitle: pd.toString()})})
  searchedDatasets = searchedDatasets?.map((sd: DatasetInfo) => {return ({...sd, formatedTitle: sd.toString()})})

  useEffect(() => {
    selectDatasets(selectedDatasetsObjArr);
  }, [selectedDatasetsObjArr]);

  const onPage = (event: any) => {
    setLazyParams(event);
  };
  const onSort = (event: any) => {
    setLazyParams(event);
  };

  const searchDatasets = async (event: { query: string }) => {
    if (event.query.length >= 3) {
      setSearchedQuery(event.query);
    }

    /*   
    const searchResults = await searchQuery(query);
    if (searchResults !== undefined) {
      try {
        const formatedSearch = searchResults.map((sr: any) => {
          const formated = { ...sr, formatedTitle: sr.formatedTitle, id: sr.id };
          return formated;
        });
        setFilteredDatasets(await formatedSearch);
      } catch (error) {
        console.log(error);
      }
    } */
  };

  const handleOnListChange = (e: { value: any }) => {
    setSelectedDatasets(e.value); //e.value -> ARRAY OF FORMATED STRINGS
    //when changes selectedDatasets, what are formated strings from filtered result,
    //we need update selectedDatasetsObj accordingly (onAdd, onRemove)
    let selectedObj = searchedDatasets?.find((fd: any) => e.value[e.value.length - 1] === fd.formatedTitle);
    //when dataset is added in search field, we add selectedDataset Object to array
    if (selectedObj !== undefined) {
      setSelectedDatasetsObjArr([...selectedDatasetsObjArr, selectedObj]);
      selectedObj = undefined;
      setSearchedQuery(null);
      //setFilteredDatasets([]);
      //when dataset is removed in search field, we filter out selectedDataset Object from array
    } else {
      const mapSelectedDatasets: Array<any> = selectedDatasetsObjArr.filter((sdObj) => {
        return e.value.find((sd: any) => {
          return sd === sdObj.formatedTitle;
        });
      });
      setSelectedDatasetsObjArr(mapSelectedDatasets);
    }
    e.value = "";
  };

  useEffect(() => {
    if (updatedDatasets.length < selectedDatasetsObjArr.length) {
      setSelectedDatasetsObjArr(updatedDatasets);
    }
  }, [updatedDatasets]);

  const handleDatasetSelection = (e: { value: any }) => {
    //dataset selection on table
    //if multiple e.value is an Array
    //const selectedTitles = e.value.map((f: any) => f.formatedTitle);
    const selectedDataset = e.value.formatedTitle;
    const tempArr = [...selectedDatasetsObjArr, e.value];
    const uniqueObjArr = getUniqueObjectsByProperty(tempArr, "identifier");
    if (!selectedDatasets.includes(selectedDataset)) {
      setSelectedDatasets([...selectedDatasets, selectedDataset]);
      setSelectedDatasetsObjArr(uniqueObjArr);
    } else {
      //remove if includes - then double click in table
      const updatedArr = removeItemById([...selectedDatasetsObjArr], e.value.identifier);
      const updatedList = removeItem([...selectedDatasets], e.value.formatedTitle);
      setSelectedDatasets(updatedList);
      setSelectedDatasetsObjArr(updatedArr);
    }
  };

  const rowClass = (data: any) => {
    return {
      "row-selected": selectedDatasetsObjArr.find((s) => s.identifier === data.identifier),
    };
  };

  const GroupsRowFilterTemplate = (e: any) => {
    const handleGroupsSelection = (e: any) => {
      const checkedArr = getChecked(e.value);
      const selectedGroupsObj: any = checkedArr.map((k: number) => searchTree(allGroups[0], k));
      const selectedGroupsLabels: any = selectedGroupsObj.map((obj: any) => obj.label);
      setSelectedGroups(e.value);
      setFilters({ ...filters, group: { ...filters.group, value: selectedGroupsLabels } });
    };
    return (
      <TreeSelect
        value={selectedGroups}
        options={allGroups}
        onChange={handleGroupsSelection}
        selectionMode="checkbox"
        metaKeySelection={false}
        placeholder="Select group"
        className="fullWidth"
        display="chip"
      />
    );
  };

  /*   useEffect(() => {
    console.log(ref, width, height);
  }, [ref, width, height]); */

  return (
    <div className="column fullWidth">
      <div className="selectionPanel fullWidth">
        {/*  <GroupsRowFilterTemplate /> */}
        <div className="autocomplete">
          <AutoComplete
            minLength={3}
            value={selectedDatasetsObjArr.map((s) => {
              return s.formatedTitle;
            })}
            suggestions={searchedDatasets?.map((f: any) => {
              return f.formatedTitle;
            })}
            completeMethod={searchDatasets}
            multiple
            onChange={handleOnListChange}
            placeholder="start type here to search..."
            aria-label="Datasets"
            className="autocomplete"
            inputClassName=""
            panelClassName="text"
            //removeIcon={<i className="pi pi-times removeIcon"></i>}
          />
        </div>
        <Divider />
        <DataTable
          value={paginatedData}
          lazy
          editMode="cell"
          selectionMode="single"
          selection={selectedDatasetsObjArr.map((s) => {
              return s.formatedTitle;
            })}
          onSelectionChange={handleDatasetSelection}
          dataKey="identifier"
          paginator
          paginatorPosition="top"
          rows={25}
          pageLinkSize={5}
          alwaysShowPaginator={false}
          responsiveLayout="scroll"
          className="text row fullWidth"
          rowClassName={rowClass}
          //filterDisplay="row"
          emptyMessage="No datasets found."
          onPage={onPage}
          onSort={onSort}
          first={lazyParams.first}
          totalRecords={datasetsCount.data}
          sortField={lazyParams.sortField}
          sortOrder={lazyParams.sortOrder}
          //globalFilterFields={["title", "unit", "group"]}
          //filters={filters}
          showGridlines
          loading={isLoadingTable}
        >
          <Column
            key="dataset"
            field="title"
            header="Dataset"
            filter={false}
            showFilterMenu={false}
            filterPlaceholder="Search by dataset"
            //sortable
            className="row"
            style={{ width: "30rem" }}
          ></Column>
          <Column
            key="unit"
            field="unit"
            filter={false}
            header="Unit"
            filterPlaceholder="Search by unit"
            className="row"
            //sortable
            style={{ width: "10px" }}
          ></Column>
          {/*   <Column
        key="group"
        field="group"
        filter={true}
        header="Group"
        showFilterMenu={false}
        filterElement={groupsRowFilterTemplate}
        filterPlaceholder="Search by group"
        sortable
        className="row"
        onFilterClear={() => setSelectedGroups(null)}
        style={{ width: "1rem" }}
      ></Column> */}
        </DataTable>
      </div>
    </div>
  );
};

export default DatasetSelection;
